module.exports = __webpack_public_path__ + "static/media/photo.08352037.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/images/photo.jpg
// module id = 331
// module chunks = 0